/**
 * Mapping from legacy/internal capability names to actual backend keys
 * This ensures compatibility between the code and backend API
 */
const CAPABILITY_KEY_MAP = {
  // Script generation
  'script_generation': 'script_from_concept',
  'script': 'script_from_concept',
  
  // Character generation
  'character_generation': 'character_profiles',
  'characters': 'character_profiles',
  
  // Image generation
  'professional_image': 'image_generation',
  'fast_image': 'image_generation',
  'reference_image': 'image_generation',
  'image': 'image_generation',
  
  // Video generation
  'text_to_video': 'Text to video',
  'image_to_video': 'Image to video',
  'video_generation': 'Text to video',
  
  // Text to image (for storyboard frames)
  'text_to_image': 'Text to image',
  'cinematic_image': 'Text to image',
  
  // Image reference to image
  'image_ref_to_image': 'Image reference to image',
  'quick_image': 'Image reference to image',
  
  // Prompts
  'video_prompt': 'video_prompt',
  'frame_prompts': 'frame_prompts',
  
  // Reasoning
  'reasoning': 'reasoning',
  'ai_reasoning': 'reasoning'
};

/**
 * Get selected models from localStorage
 * @returns {Object} Selected models by capability key
 */
export function getSelectedModels() {
  try {
    const stored = localStorage.getItem('selectedAIModels');
    return stored ? JSON.parse(stored) : {};
  } catch (error) {
    console.error('Failed to get selected models:', error);
    return {};
  }
}

/**
 * Get model key for a specific capability
 * Maps internal capability names to actual backend keys
 * @param {string} capabilityKey - Capability key (e.g., 'script_generation', 'fast_image')
 * @returns {string|null} Model key or null if not selected
 */
export function getModelForCapability(capabilityKey) {
  const selectedModels = getSelectedModels();
  
  // First try the exact key
  if (selectedModels[capabilityKey]) {
    return selectedModels[capabilityKey];
  }
  
  // Then try the mapped key
  const mappedKey = CAPABILITY_KEY_MAP[capabilityKey];
  if (mappedKey && selectedModels[mappedKey]) {
    return selectedModels[mappedKey];
  }
  
  // Log for debugging
  console.log(`🔍 Model lookup for '${capabilityKey}':`, {
    directMatch: selectedModels[capabilityKey],
    mappedKey: mappedKey,
    mappedMatch: mappedKey ? selectedModels[mappedKey] : null,
    allSelected: Object.keys(selectedModels)
  });
  
  return null;
}

/**
 * Clear selected models
 */
export function clearSelectedModels() {
  localStorage.removeItem('selectedAIModels');
}
